var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trade-chart" },
    [
      !_vm.assets
        ? [
            _c(
              "div",
              { staticClass: "container__no-data" },
              [
                _c("md-icon", { staticClass: "md-size-4x" }, [_vm._v("send")]),
                _vm._v(" "),
                _c("div", { staticClass: "text_large" }, [
                  _vm._v(_vm._s(_vm.i18n.trd_no_pairs()))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text_description text_margin text_medium" },
                  [_vm._v(_vm._s(_vm.i18n.trd_no_pairs_exp()))]
                )
              ],
              1
            )
          ]
        : [
            _c("div", { staticClass: "trade-chart__header" }, [
              _c("div", { staticClass: "text_large" }, [
                _vm._v(_vm._s(_vm.i18n.trd_market_price()))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "trade-chart__header_balance text_medium" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.i18n.trd_balance({
                        base: _vm.baseAmount,
                        quote: _vm.quoteAmount
                      })
                    )
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "trade-chart__container" },
              [
                _c(
                  "div",
                  { staticClass: "trade-chart__labels" },
                  [
                    _c("scale-tabs", {
                      attrs: { asset: _vm.assets, isPending: _vm.isPending },
                      model: {
                        value: _vm.scale,
                        callback: function($$v) {
                          _vm.scale = $$v
                        },
                        expression: "scale"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-25 md-medium-size-30 md-small-size-40"
                      },
                      [
                        _c("assets-select", {
                          attrs: { pairs: _vm.pairs, assets: _vm.assets }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.history.length
                  ? _c("d3-chart", {
                      staticClass: "trade-chart__chart",
                      attrs: {
                        data: _vm.roundChartVals(_vm.history),
                        volume: _vm.roundChartVals(_vm.normalizedVolume),
                        currency: _vm.assets.split("/")[1],
                        scale: _vm.scale,
                        isPending: _vm.isPending,
                        precision: _vm.precision,
                        requiredTicks: _vm.requiredTicks
                      }
                    })
                  : _c("div", { staticClass: "chart-container__loader" }, [
                      _vm._v("Loading...")
                    ])
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf6fcbb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf6fcbb4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/trade/index/components/chart/Trade.ChartWidget.vue
// module id = 7OKo
// module chunks = 1